import { ApolloClient, InMemoryCache, ApolloLink, Observable } from '@apollo/client'
import { onError } from '@apollo/client/link/error'

import runErrorLink from './errorLink'
import httpLink from './httpLink'
import { currentBrandVar } from './initial-data'

const cache = new InMemoryCache({ addTypename: true })

const errorLink = onError((...args) => {
  // expose client to error handler
  return runErrorLink(client, ...args)
})

// const retryLink = new RetryLink({ attempts: 3 })

/*
  Add x-hive-brand header with current brand id
*/

const brandHeaderLink = new ApolloLink((operation, forward) => {
  const currentBrand = currentBrandVar()
  
  if (currentBrand?.id) {
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'x-hive-brand': String(currentBrand.id)
      }
    }))
  }
  
  return forward(operation)
})

/*
  Drop __typename from variables
*/

const cleanTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key: string, value: any) =>
      key === '__typename' ? undefined : value
    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    )
  }
  return forward(operation).map((data) => {
    return data
  })
})

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([ brandHeaderLink, cleanTypeName, errorLink, httpLink ])
})

export { cache }
export default client
